"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleItemQuery = void 0;
var models_1 = require("../../models");
var base_item_query_class_1 = require("./base-item-query.class");
var SingleItemQuery = /** @class */ (function (_super) {
    __extends(SingleItemQuery, _super);
    function SingleItemQuery(config, queryService, codename) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this.codename = codename;
        if (!codename) {
            throw Error("'codename' has to be configured for 'SingleItemQuery' query");
        }
        return _this;
    }
    /**
     * Indicates depth of query that affects loading of nested linked items.
     * @param depth Depth of the query (> 0)
     */
    SingleItemQuery.prototype.depthParameter = function (depth) {
        this.parameters.push(new models_1.Parameters.DepthParameter(depth));
        return this;
    };
    /**
     * Gets the runnable Observable
     */
    SingleItemQuery.prototype.toObservable = function () {
        return _super.prototype.runSingleItemQuery.call(this, this.codename);
    };
    /**
     * Gets 'Url' representation of query
     */
    SingleItemQuery.prototype.getUrl = function () {
        return _super.prototype.getSingleItemQueryUrl.call(this, this.codename);
    };
    return SingleItemQuery;
}(base_item_query_class_1.BaseItemQuery));
exports.SingleItemQuery = SingleItemQuery;
//# sourceMappingURL=single-item-query.class.js.map